import React from 'react';
import PropTypes from 'prop-types';
import {formatNumber} from 'utils/number'


const TextAmount = ({ value, decimals, className, minusColor}) => {   
    let formatted = formatNumber(value, decimals);
    let minusStyle = {};
    if (value < 0){
        let color = minusColor !== undefined ? minusColor : "#ff0000"; //default.        
        minusStyle = {
            color : color
        } 
    }

    return (
        <span className={className} style={minusStyle}>{formatted}</span>
      );
};

TextAmount.propTypes = {
  value: PropTypes.number,
  decimals : PropTypes.number,
  className : PropTypes.string,
  minusColor : PropTypes.string
};

export default TextAmount;
